import React from 'react';
import { ArrowRight } from 'lucide-react';
import { img } from '../mock';

const About = () => {
  const galleryLoop = [...img.gallery, ...img.gallery];
  return (
    <section id="about" className="py-16 scroll-mt-20">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <h2 className="font-display font-semibold text-white text-3xl md:text-5xl leading-tight max-w-4xl reveal">
          Il mio lavoro, la mia passione, <span className="gold-text">quello che imparerai</span>
        </h2>

        <div className="mt-12 grid lg:grid-cols-[0.9fr_1.1fr] gap-10 items-start">
          <div className="rounded-2xl overflow-hidden border border-white/10 reveal">
            <img src={img.portrait} alt="Matteo — Architetto" className="w-full h-full object-cover aspect-[4/5]" />
          </div>
          <div className="reveal">
            <div className="font-display font-bold text-white text-4xl">MATTEO</div>
            <div className="mt-1 label-mono">Architetto / Unreal Engine Specialist</div>
            <div className="mt-6 space-y-4 text-neutral-300 leading-relaxed">
              <p>
                Sono Matteo, architetto e fondatore di Unreal Viz. Uso Unreal Engine nella visualizzazione
                architettonica da oltre 10 anni, e la scelta di entrare nel mondo della formazione nasce direttamente da
                quegli anni passati sul campo a imparare, sbagliare e migliorare.
              </p>
              <p>
                So bene quanto sia difficile trovare materiale serio. Tutorial sparsi, documentazione in inglese,
                contenuti che saltano dal gaming all&rsquo;automotive senza mai entrare nel vivo dell&rsquo;archviz. Ho
                perso mesi a setacciare risorse che non erano pensate per me, e probabilmente tu stai vivendo la stessa
                cosa.
              </p>
              <p className="text-white">
                Per questo ho raccolto tutto quello che ho costruito in 10 anni di lavoro reale e l&rsquo;ho trasformato
                in un percorso strutturato, in italiano, pensato esclusivamente per l&rsquo;archviz con Unreal Engine.
                Non una raccolta di tutorial. Un metodo.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Marquee gallery */}
      <div className="mt-16 overflow-hidden">
        <div className="uv-marquee-track gap-4">
          {galleryLoop.map((src, i) => (
            <div key={i} className="w-[340px] h-[220px] rounded-xl overflow-hidden border border-white/10 shrink-0">
              <img src={src} alt="" className="w-full h-full object-cover" loading="lazy" />
            </div>
          ))}
        </div>
      </div>

      {/* Portfolio CTA */}
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 mt-16">
        <div className="rounded-2xl border border-white/10 bg-[var(--uv-surface)] p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-6 reveal">
          <div>
            <h3 className="font-display font-semibold text-white text-2xl md:text-3xl">Dai un&rsquo;occhiata ad alcuni lavori</h3>
            <p className="mt-2 text-neutral-400">Ottieni l&rsquo;accesso per visionare alcuni lavori eseguiti con Unreal Engine.</p>
          </div>
          <a href="#contatti"
            className="inline-flex items-center gap-2 px-7 py-4 rounded-full border border-white/25 text-white font-medium hover:border-[var(--uv-gold)] hover:text-[var(--uv-gold)] transition-colors shrink-0">
            Guarda il Portfolio <ArrowRight size={18} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
